import { useState } from "react";
import type { Account } from "@veto/domain";
import { userFacingMessage } from "@veto/domain";
import { listContacts, listConversations } from "@veto/storage";
import { createBackupPackage, downloadBackupJson } from "../messaging/backup";

export function BackupExportButton({
  account,
  onToast,
}: {
  account: Account;
  onToast: (msg: string) => void;
}) {
  const [pass, setPass] = useState("");
  const [busy, setBusy] = useState(false);

  return (
    <div className="stack">
      <div className="field">
        <label htmlFor="backupPass">Backup passphrase</label>
        <input
          id="backupPass"
          type="password"
          autoComplete="new-password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          placeholder="Strong passphrase"
        />
      </div>
      <button
        className="btn"
        type="button"
        disabled={busy || pass.length < 8}
        onClick={() => {
          setBusy(true);
          void (async () => {
            try {
              const payload = {
                v: 1,
                exportedAt: Date.now(),
                account: {
                  displayName: account.displayName,
                  messagingPublicKeyHex: account.messagingPublicKeyHex,
                  hybridPublicKeyHex: account.hybridPublicKeyHex,
                  assuranceMode: account.assuranceMode,
                },
                contacts: await listContacts(),
                conversations: (await listConversations()).map((c) => ({
                  id: c.id,
                  type: c.type,
                  title: c.title,
                  contactId: c.contactId,
                })),
              };
              const pkg = await createBackupPackage(pass, payload);
              downloadBackupJson(pkg);
              onToast("Encrypted backup downloaded — store passphrase offline");
              setPass("");
            } catch (e) {
              onToast(userFacingMessage(e));
            } finally {
              setBusy(false);
            }
          })();
        }}
      >
        {busy ? "Encrypting…" : "Download encrypted backup"}
      </button>
      <p className="muted text-sm">
        Backups are end-to-end encrypted — without the passphrase, not even Veto could
        read or restore it. Message bodies are not included (contacts + conversation
        metadata only).
      </p>
    </div>
  );
}
